import { render, staticRenderFns } from "./ProgramAssetWidget.vue?vue&type=template&id=2c8f70ed&scoped=true&lang=pug&"
import script from "./ProgramAssetWidget.vue?vue&type=script&lang=js&"
export * from "./ProgramAssetWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8f70ed",
  null
  
)

export default component.exports